import { Box, Button, Chip, Stack, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Grid as GridLoader } from 'react-loader-spinner';
import { useDispatch } from 'react-redux';
import Utility from '../api/utility';
import { show } from '../reducers/notificationSlice';
import State from './State';
export default function Country() {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [countryCode, setCountryCode] = useState('');

  useEffect(() => {
    Utility.getCountries()
      .then(({ data }) => {
        const items = Array.isArray(data) ? data : [];
        setData(items);
        setFilteredData(items);
      })
      .catch((err) =>
        dispatch(show({ message: err?.response?.data?.message, open: true, severity: 'error' }))
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function changeVisibility(visibility, countryID) {
    Utility.updateCountryVisibility(visibility, countryID)
      .then(() => {
        setData((_o) => [
          ..._o,
          ..._o.map((ele) => {
            if (ele.id === countryID) {
              ele.showCountry = visibility;
              return ele;
            }
            return ele;
          }),
        ]);
      })
      .catch((err) =>
        dispatch(show({ message: err.response.data.message, open: true, severity: 'error' }))
      );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <TextField
        size="small"
        placeholder={
          filteredData.length >= 0
            ? `Search Country ( Total Countries : ${filteredData.length} )`
            : 'Loading...'
        }
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          backgroundColor: 'background.paper',
        }}
        onChange={(e) => {
          if (e.target.value === '' || e.target.value.length < 3) {
            setFilteredData(data);
            return;
          }
          setFilteredData(
            data.filter((ele) => {
              return new RegExp(e.target.value, 'ig').test(ele.name);
            })
          );
        }}
      />
      {Array.isArray(filteredData) ? (
        <Box sx={{ flex: 1, overflow: 'auto', width: '100%' }}>
          <Stack spacing={1.5}>
            {filteredData?.map((ele) => (
              <Box
                key={ele.code}
                sx={{
                  p: 2,
                  borderRadius: '12px',
                  cursor: 'pointer',
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  alignItems: { xs: 'flex-start', md: 'center' },
                  justifyContent: 'space-between',
                  gap: { xs: 2, md: 0 },
                  backgroundColor: 'action.hover',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: 'primary.main',
                    color: 'primary.contrastText',
                    transform: 'translateX(4px)',
                    boxShadow: 2,
                    '& .MuiTypography-root': {
                      color: 'primary.contrastText',
                    },
                  },
                }}
              >
                <Box>
                  <Typography
                    variant="h6"
                    sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}
                  >
                    {ele.name}&nbsp;({ele.code})
                    <Chip
                      label={ele.showCountry ? 'Active' : 'Inactive'}
                      color={ele.showCountry ? 'success' : 'error'}
                      size="small"
                    />
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Phone Code: {ele.phoneCode}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                  <Button
                    variant="contained"
                    color={!ele.showCountry ? 'success' : 'error'}
                    size="small"
                    onClick={() => changeVisibility(!ele.showCountry, ele.id)}
                  >
                    {ele.showCountry ? 'Deactivate' : 'Activate'}
                  </Button>
                  <Button
                    variant="contained"
                    color="info"
                    size="small"
                    onClick={() => setCountryCode(ele.code)}
                  >
                    Show States
                  </Button>
                </Box>
              </Box>
            ))}
            {countryCode && <State code={countryCode} setCountryCode={setCountryCode} />}
          </Stack>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            minHeight: '500px',
            alignItems: 'center',
          }}
        >
          <GridLoader />
        </Box>
      )}
    </Box>
  );
}
